import './divider.less';

import React from 'react';
import className from 'classnames';

export default (props)=>
  <div style={props.style} className={className("page-editor-sidebar-divider", props.className)} />;
